import { render, staticRenderFns } from "./voiceGalleryAcc.vue?vue&type=template&id=44792816&scoped=true"
import script from "./voiceGalleryAcc.vue?vue&type=script&lang=js"
export * from "./voiceGalleryAcc.vue?vue&type=script&lang=js"
import style0 from "./voiceGalleryAcc.vue?vue&type=style&index=0&id=44792816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44792816",
  null
  
)

export default component.exports